import { takeEvery, select } from 'redux-saga/effects';
import {
  tags as tagsSelectors,
  ui as uiSelectors,
  flyerGibs as flyerGibsSelectors,
  flyers as flyersSelectors,
} from 'flux/selectors';
import { retailerCart as retailerCartActions } from 'flux/actions';
import { sendPostMessage } from 'utils';
import { eventFields } from 'utils/eventFields';

export function* addProduct({ payload: { tagId } }) {
  const tag = yield select(tagsSelectors.selectTag, tagId);
  const flyerGib = yield select(flyerGibsSelectors.selectFlyerGib, tag.id);
  const currentFlyer = yield select(flyersSelectors.selectCurrentFlyer);

  const event = {
    id: currentFlyer?.id ?? '',
    ...eventFields.flyer.getCustomLabel(currentFlyer),
    ...eventFields.tag.getProductName(tag),
    ...eventFields.gib.getProductCode(flyerGib),
    ...eventFields.tag.getFullPrice(tag),
    ...eventFields.tag.getDiscountedPrice(tag),
  };

  const targetOrigin = yield select(uiSelectors.selectPostMessageTargetOrigin);
  sendPostMessage('addToCart', event, targetOrigin); // addToCart is used in the init
}

export default function* () {
  yield takeEvery(retailerCartActions.types.ADD_PRODUCT, addProduct);
}
